<template>
    <div class="shop__addresses">

        <div class="shop__address-block" style="padding-top: 0">
            <div class="shop__paymentmode">
                <div class="shop__address-block-title">{{Strings['Shop.OptionBillingWhoPays']}}</div>
                <Radiobutton :label="Strings['Shop.OptionBillingOnePaysAll']"
                             :radioValue="PaymentModes.OnePaysAll"
                             :value="CurrentTransaction.paymentMode"
                             @change="updatePaymentMode"
                             display="block" />
                <Radiobutton :label="Strings['Shop.OptionBillingPerUnloadingPoint']"
                             :radioValue="PaymentModes.EveryonePaysSeparate"
                             :value="CurrentTransaction.paymentMode"
                             @change="updatePaymentMode"
                             display="block" />
                <Radiobutton :label="Strings['Shop.OptionBillingOtherConfiguration']"
                             :radioValue="PaymentModes.Other"
                             :value="CurrentTransaction.paymentMode"
                             @change="updatePaymentMode"
                             display="block" />
            </div>
        </div>

        <hr />

        <div v-if="CurrentTransaction.paymentMode === PaymentModes.Other">
            <div class="shop__address-block">
                <TextareaWithLabel :label="Strings['Shop.LabelBillingOtherConfiguration']"
                                   :value="CurrentTransaction.differentPaymentConfigurationText"
                                   @change="updateConfigurationText"
                                   rules="required"
                                   rows="5" />
            </div>
            <hr />
        </div>

        <div>
            <div v-for="(pos, index) in CurrentTransaction.positions" :key="pos.id">
                <div class="shop__address-block">
                    <div class="shop__address-block-title">{{WETitle}} {{(index + 1)}}</div>
                    <PositionProductAndPriceInfo :position="pos" type="horizontal" />
                    <div class="shop__address-block-spacer-big"></div>
                    <ShopEditableAddress :address="pos.warenempfaenger"
                                         :showCumulus="enableCumulus && (CurrentTransaction.paymentMode === PaymentModes.EveryonePaysSeparate || pos.warenempfaenger.id == SelectedAddressId)"
                                         :showEmail="pos.warenempfaenger.id == SelectedAddressId"
                                         :allowZipCityEdit="false"
                                         @fixAddress="fixWE(pos.id)" />
                </div>
                <hr />
            </div>
        </div>

        <div class="shop__address-block">
            <div class="shop__address-block-title">{{AGTitle}}</div>
            <div v-if="MigrosLoginAG !== null">
                <!--fixed migros login AG-->
                <ShopEditableAddress :address="MigrosLoginAG" :showCumulus="enableCumulus && (CurrentTransaction.paymentMode !== PaymentModes.EveryonePaysSeparate)" @fixAddress="fixAG" />
            </div>
            <div v-if="MigrosLoginAG === null">
                <!--let user enter/pick AG-->
                <div v-show="CurrentTransaction.paymentMode !== PaymentModes.Other">
                    <SelectWithLabel :label="Strings['Shop.LabelPickAuftraggeber']" v-model="SelectedAddressId" rules="required" :options="AuftraggeberOptions" />
                    <div class="shop__address-block-spacer-small"></div>
                </div>
                <ShopEditableAddress v-if="SelectedAddressId === '-1' && CustomAGAddressId !== -1"
                                     :address="CurrentTransaction.auftraggeber"
                                     :showCumulus="enableCumulus && (CurrentTransaction.paymentMode !== PaymentModes.EveryonePaysSeparate)"
                                     @fixAddress="fixAG" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { clone } from '@/utils/utils';
    import { PaymentModes, AddressSource } from '@/utils/constants';
    import PositionProductAndPriceInfo from './PositionProductAndPriceInfo';
    import ShopEditableAddress from './ShopEditableAddress'
    import Position from '@/models/Position';
    import Transaction from '@/models/Transaction';
    import Address from '@/models/Address';

    export default {
        props: {
            //    material: Object
            enableCumulus: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                SelectedAddressId: '',
                CustomAGAddressId: -1
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'DirectPriceActivated'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['auftraggeber', 'positions.warenempfaenger|regulierer']).first();
            },
            PaymentModes() {
                return PaymentModes;
            },
            WETitle() {
                switch (this.CurrentTransaction.paymentMode) {
                    case PaymentModes.OnePaysAll:
                    case PaymentModes.Other:
                        return this.Strings['Shop.DeliveryAddress_BnT'];
                    case PaymentModes.EveryonePaysSeparate:
                        return this.Strings['Shop.DeliveryAndBillingAddress_BnT'];
                    default:
                        return null;
                }
            },
            AGTitle() {
                switch (this.CurrentTransaction.paymentMode) {
                    case PaymentModes.OnePaysAll:
                        return this.Strings['Shop.AuftraggeberAndBillingAddress'];
                    default:
                        return this.Strings['Shop.Auftraggeber'];
                }
            },
            MigrosLoginAG() {
                return Address.query().where('isAuftraggeber', true).first();
            },
            AuftraggeberOptions() {
                let options = this.CurrentTransaction.positions.map((pos, index) => { return { text: this.Strings['Shop.SameAsDeliveryAddress'] + ' ' + (index + 1), id: String(pos.warenempfaenger_id) } });
                options.push({ text: this.Strings['Shop.OptionOtherAddress'], id: '-1' }); //add "other" choice
                return options;
            }
        },
        watch: {
            SelectedAddressId(newAddressId) {
                let vm = this;

                if (newAddressId === '-1') {
                    //user selected "other address" from the dropdown -> create a blank address
                    if (vm.CustomAGAddressId === -1) {
                        Address.insert({ data: { addressSource: AddressSource.ManualAddress } }).then((result) => {
                            let newAG = result.addresses[0];
                            Transaction.update({
                                id: vm.CurrentTransaction.id,
                                auftraggeber: newAG
                            }).then(() => {
                                //update transaction to use the new AG
                                vm.CustomAGAddressId = newAG.id;
                            });
                        });
                    } else {
                        //set custom address as AG
                        Transaction.update({
                            id: vm.CurrentTransaction.id,
                            auftraggeber: Address.find(vm.CustomAGAddressId)
                        });
                    }
                } else {
                    //set lieferadresse as AG
                    Transaction.update({
                        id: vm.CurrentTransaction.id,
                        auftraggeber: Address.find(newAddressId)
                    });
                }
            }
        },
        methods: {
            ...mapActions([
                'CalculatePrices'
            ]),
            updatePaymentMode(newMode) {
                Transaction.update({
                    id: this.CurrentTransaction.id,
                    paymentMode: newMode
                });

                //clear all regulierers
                this.CurrentTransaction.positions.forEach((pos) => {
                    if (pos.regulierer !== null) {
                        Position.update({
                            id: pos.id,
                            regulierer: null,
                            regulierer_id: null
                        });
                    }
                });

                switch (newMode) {
                    case PaymentModes.OnePaysAll:
                        //do nothing, AG will be the one that pays
                        break;
                    case PaymentModes.EveryonePaysSeparate:
                        //set pos.regulierer = pos.warenempfaenger
                        this.CurrentTransaction.positions.forEach((pos) => {
                            Position.update({
                                id: pos.id,
                                regulierer: pos.warenempfaenger
                            });
                        });
                        break;
                    case PaymentModes.Other:
                        //do nothing -> we will have an interaktionsformular
                        break;
                }

                if (newMode === PaymentModes.Other && (this.CurrentTransaction.auftraggeber === null || this.CurrentTransaction.auftraggeber.isAuftraggeber === false)) {
                    this.SelectedAddressId = '-1';
                }
            },
            updateConfigurationText(newValue) {
                Transaction.update({
                    id: this.CurrentTransaction.id,
                    differentPaymentConfigurationText: newValue
                });
            },
            fixAG() {
                //user wants to "fix" the current AG Address -> create a clone of it as a new manual address
                let newAG = clone(this.CurrentTransaction.auftraggeber);
                delete newAG.id; //remove id (will be autogenerated on insert)
                newAG.customerId = ''; //reset customerId
                newAG.addressSource = AddressSource.ManualAddress; //make a manual address out of it

                //change the "old" auftraggeber's "isAuftraggeber" flag to false
                if (this.CurrentTransaction.auftraggeber.isAuftraggeber === true) {
                    Address.update({
                        id: this.CurrentTransaction.auftraggeber.id,
                        isAuftraggeber: false
                    });
                }

                //now update the transaction to use the new AG
                Address.insert({ data: newAG })
                    .then((createdData) => {
                        Transaction.update({
                            id: this.CurrentTransaction.id,
                            auftraggeber: createdData.addresses[0]
                        }).then(this.recalculate);
                        this.CustomAGAddressId = createdData.addresses[0].id;
                    });

                //now since the AG became "anonymous", we have to switch all the other addresses to anonymous too, otherwise they point to the old AG which is wrong
                this.CurrentTransaction.positions.forEach((pos) => {
                    if (pos.warenempfaenger !== null && pos.warenempfaenger.customerId !== '') {
                        this.fixWE(pos.id);
                    }
                    if (pos.regulierer !== null && pos.regulierer.customerId !== '') {
                        this.fixRE(pos.id);
                    }
                });
            },
            fixWE(positionId) {
                let position = Position.query().with('warenempfaenger').where('id', positionId).first();

                //clone the WE
                let newWE = clone(position.warenempfaenger);
                delete newWE.id; //remove id (will be autogenerated on insert)
                newWE.isAuftraggeber = false; //not AG anymore
                newWE.customerId = ''; //reset customerId
                newWE.addressSource = AddressSource.ManualAddress; //make a manual address out of it

                Address
                    .insert({ data: newWE })
                    .then((createdData) => {
                        Position.update({
                            id: positionId,
                            warenempfaenger: createdData.addresses[0]
                        }).then(this.recalculate);
                    });
            },
            recalculate() {
                if (this.DirectPriceActivated) {
                    this.CalculatePrices();
                }
            }
        },
        mounted() {
            //when this component is mounted, we are in multi-abladestellen mode. if no paymentMode is set or it's SingleUP, default it to OnePaysAll
            if (this.CurrentTransaction.paymentMode === null || this.CurrentTransaction.paymentMode === PaymentModes.SingleUP) {
                this.updatePaymentMode(PaymentModes.OnePaysAll);
            }

            if (this.CurrentTransaction.auftraggeber_id !== null) {
                //if we have an AG, check if it is one of the WE of the positions
                for (var i = 0; i < this.CurrentTransaction.positions.length; i++) {
                    if (this.CurrentTransaction.positions[i].warenempfaenger_id === this.CurrentTransaction.auftraggeber_id) {
                        this.SelectedAddressId = String(this.CurrentTransaction.auftraggeber_id);
                    }
                }

                //if still null, we set it to -1 (custom)
                if (this.SelectedAddressId === '') {
                    //if an "official" AG address is present, set the CustomAGAddressId to its id, otherwise a new AG Address is created
                    if (this.CurrentTransaction.auftraggeber.isAuftraggeber === true) {
                        this.CustomAGAddressId = this.CurrentTransaction.auftraggeber_id;
                        this.SelectedAddressId = '-1';
                    } else {
                        //an invalid AG is set on the transaction, remove it
                        Transaction.update({
                            id: this.CurrentTransaction.id,
                            auftraggeber_id: null,
                            auftraggeber: null
                        }).then(() => { this.SelectedAddressId = '-1'; });
                    }
                }
            }
        },
        components: {
            PositionProductAndPriceInfo,
            ShopEditableAddress
        }
    };
</script>